import type { DashboardSite } from "../lib/api";
import { summarize, formatNumber, formatDelta, deltaClass } from "../lib/format";
import { Sparkline } from "./Sparkline";

export function SiteRow({ site }: { site: DashboardSite }) {
  const visits = summarize(site.snapshots, "visits");
  const uniques = summarize(site.snapshots, "uniqueVisitors");
  const pageviews = summarize(site.snapshots, "pageviews");

  return (
    <a
      href={`https://${site.hostname}`}
      target="_blank"
      rel="noopener noreferrer"
      className="
        group grid grid-cols-12 gap-4 items-center
        px-4 py-5
        border-b border-hairline
        hover:bg-canvas transition-colors duration-150
      "
    >
      {/* Site name */}
      <div className="col-span-12 md:col-span-3 min-w-0">
        <div className="font-display text-lg text-ink truncate group-hover:underline decoration-1 underline-offset-4">
          {site.displayName}
        </div>
        <div className="font-mono text-[11px] text-faint mt-0.5 truncate">
          {site.hostname}
        </div>
      </div>

      {/* Three metrics */}
      <Metric label="VISITS"    summary={visits} />
      <Metric label="UNIQUE"    summary={uniques} />
      <Metric label="PAGEVIEWS" summary={pageviews} />

      {/* Sparkline */}
      <div className="col-span-12 md:col-span-3 flex justify-end items-center">
        <Sparkline snapshots={site.snapshots} field="visits" width={140} height={32} />
      </div>
    </a>
  );
}

function Metric({
  label,
  summary,
}: {
  label: string;
  summary: ReturnType<typeof summarize>;
}) {
  return (
    <div className="col-span-4 md:col-span-2">
      <div className="text-[10px] tracking-editorial text-faint uppercase mb-1.5 font-medium">
        {label}
      </div>
      <div className="font-mono tnum text-2xl text-ink leading-none font-medium">
        {formatNumber(summary.today)}
      </div>
      <div className="flex items-center gap-2 mt-1.5 text-[11px] tnum">
        <span className={deltaClass(summary.dod)}>
          {formatDelta(summary.dod)}
        </span>
        <span className="text-faint">D/D</span>
        <span className="text-whisper">·</span>
        <span className={deltaClass(summary.wow)}>
          {formatDelta(summary.wow)}
        </span>
        <span className="text-faint">W/W</span>
      </div>
    </div>
  );
}
